import React from 'react'
import { object } from 'prop-types'

const SummaryHeader = ({ data }) => {
  var fr = data.get('date_from')
  var to = data.get('date_to')

  if (data.get('by') === "or") {
    fr = data.get('or_from')
    to = data.get('or_to')
  }

  return (
    <table className="table table-bordered table-condensed">
      <tbody>
        <tr>
          <td width="20%">Collection From:</td>
          <td><strong>{data.get('cashier')}</strong></td>
        </tr>
        <tr>
          <td width="15%">OR/Date Range:</td>
          <td><strong>{fr} - {to}</strong></td>
        </tr>
        <tr>
          <td>Fund Type:</td>
          <td><strong>{data.get('fund')}</strong></td>
        </tr>
      </tbody>
    </table>
  )
}

SummaryHeader.propTypes = {
  data: object,
}

export default SummaryHeader



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/summary-header.js